import { createContext } from "react";
import { ShopDrawing } from "./ShopDrawing";
import { useParams } from "react-router-dom";
import { jsx as _jsx } from "react/jsx-runtime";
export const ChangePreviewContext = /*#__PURE__*/ createContext({ enabled: false, sessionId: 0 });
export function ShopDrawingChangePreview() { const params = useParams(); const session = parseInt(params.changesetId || "0"); return /*#__PURE__*/ _jsx(ChangePreviewContext.Provider, { value: { enabled: true, sessionId: session }, children: /*#__PURE__*/ _jsx(ShopDrawing, {}) }); }
